import DatePicker from 'tui-date-picker'
import 'tui-date-picker/dist/tui-date-picker.css'
import { Vue, Options } from 'vue-class-component'
@Options({
  components: {
    DatePicker
  }
})
export default class DateRangePicker extends Vue {
    today: Date = new Date()

    mounted () {
      this.initLanguage()
      this.setRangeDate()
    }

    setRangeDate () {
      const startPickerInput = document.getElementById(
        'startpicker-input'
      ) as HTMLInputElement
      const startPickerContainer = document.getElementById(
        'startpicker-container'
      ) as HTMLElement

      const endPickerInput = document.getElementById(
        'endpicker-input'
      ) as HTMLInputElement
      const endPickerContainer = document.getElementById(
        'endpicker-container'
      ) as HTMLElement

      DatePicker.createRangePicker({
        language: 'Chinese character',
        startpicker: {
          date: this.today,
          input: startPickerInput,
          container: startPickerContainer
        },
        endpicker: {
          date: this.today,
          input: endPickerInput,
          container: endPickerContainer
        },
        selectableRanges: [
          [
            this.today,
            new Date(
              this.today.getFullYear() + 1,
              this.today.getMonth(),
              this.today.getDate()
            )
          ]
        ]
      })
    }

    initLanguage () {
      // DatePicker.localeTexts['Chinese character'] = {
      //   titles: {
      //     DD: [
      //       '星期日',
      //       '星期一',
      //       '星期二',
      //       '星期三',
      //       '星期四',
      //       '星期五',
      //       '星期六'
      //     ],
      //     D: ['日', '一', '二', '三', '四', '五', '六'],
      //     MMM: [
      //       '1月',
      //       '2月',
      //       '3月',
      //       '4月',
      //       '5月',
      //       '6月',
      //       '7月',
      //       '8月',
      //       '9月',
      //       '10月',
      //       '11月',
      //       '12月'
      //     ],
      //     MMMM: [
      //       '一月',
      //       '二月',
      //       '三月',
      //       '四月',
      //       '五月',
      //       '六月',
      //       '七月',
      //       '八月',
      //       '九月',
      //       '十月',
      //       '十一月',
      //       '十二月'
      //     ]
      //   },
      //   titleFormat: 'yyyy年MMM',
      //   todayFormat: 'yyyy年MMMd日(DD)'
      // }
      DatePicker.localeTexts['Chinese character'] = {
        titles: {
          DD: [
            this.$i18n.t('sunday'),
            this.$i18n.t('monday'),
            this.$i18n.t('tuesday'),
            this.$i18n.t('wednesday'),
            this.$i18n.t('thursday'),
            this.$i18n.t('friday'),
            this.$i18n.t('saturday')
          ],
          D: [
            this.$i18n.t('sun'),
            this.$i18n.t('mon'),
            this.$i18n.t('tue'),
            this.$i18n.t('wed'),
            this.$i18n.t('thu'),
            this.$i18n.t('fri'),
            this.$i18n.t('sat')
          ],
          MMM: [
            this.$i18n.t('jan'),
            this.$i18n.t('feb'),
            this.$i18n.t('mar'),
            this.$i18n.t('apr'),
            this.$i18n.t('may1'),
            this.$i18n.t('jun'),
            this.$i18n.t('jul'),
            this.$i18n.t('aug'),
            this.$i18n.t('sep'),
            this.$i18n.t('oct'),
            this.$i18n.t('nov'),
            this.$i18n.t('dec')
          ],
          MMMM: [
            this.$i18n.t('january'),
            this.$i18n.t('february'),
            this.$i18n.t('march'),
            this.$i18n.t('april'),
            this.$i18n.t('may'),
            this.$i18n.t('june'),
            this.$i18n.t('july'),
            this.$i18n.t('august'),
            this.$i18n.t('september'),
            this.$i18n.t('october'),
            this.$i18n.t('november'),
            this.$i18n.t('december')
          ]
        },
        titleFormat: 'yyyy-MMM',
        todayFormat: 'yyyy-MMM-d(DD)'
      }
    }
}
